<header class="job-nav-header">
  <div class="job-nav-wrapper">
    <nav class="job-nav">
      <div class="job-nav-brand">
        <img alt="BeExpert.ai" class="job-nav-logo" src="/assets/images/BeExpert-logo%20(2).svg" />
      </div>
      <div class="job-nav-links hidden md:flex">
        <button class="job-nav-link" (click)="scrollTo('description')">Job description</button>
        <button class="job-nav-link" (click)="scrollTo('roles')">Roles & responsibilities</button>
        <button class="job-nav-link" (click)="scrollTo('required')">Required skills</button>
        <button class="job-nav-link" (click)="scrollTo('preferred')">Preferred skills</button>
        <button class="job-nav-link" (click)="scrollTo('eligibility')">Eligibility</button>
        <button class="job-nav-link" (click)="scrollTo('compensation')">Compensation & perks</button>
      </div>
      <div class="job-nav-actions">
        <button class="job-nav-btn-login" routerLink="/login">Login</button>
      </div>
    </nav>
  </div>
</header>

<div class="job-container pb-24 lg:pb-8">
  <ng-container *ngIf="isLoading">
    <div class="flex justify-center items-center py-20 w-full h-full">
      <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
    </div>
  </ng-container>

  <ng-container *ngIf="!isLoading && job">
    <div class="job-left">
      <a href="/" (click)="goBack($event)" class="back-link">
        <svg aria-hidden="true" class="w-4 h-4 mr-2" fill="none" stroke="currentColor" stroke-linecap="round"
          stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
          <path d="M19 12H5"></path>
          <path d="m12 19-7-7 7-7"></path>
        </svg>
        Back to jobs
      </a>

      <div class="main-card">
        <div class="job-header">
          <div class="job-logo">
            <img [src]="job.company_logo || 'https://ui-avatars.com/api/?name=' + job.company_name"
              [alt]="job.company_name">
          </div>
          <div class="job-title-sec">
            <p class="company-name">{{ job.company_name }}</p>
            <h1>{{ job.job_title }}</h1>

            <div class="job-meta-row">
              <span class="badge"><svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" stroke-linecap="round"
                  stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
                  <path d="M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
                  <rect height="14" rx="2" width="20" x="2" y="6"></rect>
                </svg> {{ job.experience_level || 'Fresher' }}</span>
              <span class="badge"><svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" stroke-linecap="round"
                  stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
                  <path
                    d="M18 5a2 2 0 0 1 2 2v8.526a2 2 0 0 0 .212.897l1.068 2.127a1 1 0 0 1-.9 1.45H3.62a1 1 0 0 1-.9-1.45l1.068-2.127A2 2 0 0 0 4 15.526V7a2 2 0 0 1 2-2z">
                  </path>
                  <path d="M20.054 15.987H3.946"></path>
                </svg> {{ job.work_mode }}</span>
            </div>

            <div class="job-meta-details">
              <span class="location"><svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" stroke-linecap="round"
                  stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
                  <path
                    d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0">
                  </path>
                  <circle cx="12" cy="10" r="3"></circle>
                </svg> {{ job.locations?.length ? job.locations.join(', ') : 'Not specified' }}</span>
              <span class="time">{{ getTimeAgo(job.published_at || job.created_at) }} &middot; {{ job.number_of_openings
                || 1 }} opening<span *ngIf="job.number_of_openings !== 1">s</span></span>
            </div>

            <div class="job-meta-row mt-2" *ngIf="job.salary_min || job.salary_max">
              <span class="badge bg-emerald-50 text-emerald-700 border-emerald-100">
                <svg class="w-3.5 h-3.5 text-emerald-600" fill="none" stroke="currentColor" stroke-linecap="round"
                  stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
                  <rect width="20" height="14" x="2" y="5" rx="2"></rect>
                  <line x1="2" x2="22" y1="10" y2="10"></line>
                </svg>
                <span class="font-medium mr-0.5" *ngIf="job.currency === 'INR'">&#8377;</span><span
                  class="font-medium mr-0.5" *ngIf="job.currency === 'USD'">$</span>
                <ng-container *ngIf="job.salary_min && job.salary_max">
                  {{ job.salary_min }}–{{ job.salary_max }}
                </ng-container>
                <ng-container *ngIf="job.salary_min && !job.salary_max">
                  {{ job.salary_min }}
                </ng-container>
                <ng-container *ngIf="!job.salary_min && job.salary_max">
                  Up to {{ job.salary_max }}
                </ng-container>
                <span *ngIf="job.payment_frequency" class="text-xs font-normal opacity-80"> {{ job.payment_frequency
                  }}</span>
              </span>
            </div>
          </div>
          
          <!-- Mobile Action Buttons (Sticky Bottom Bar, Hidden on Desktop) -->
          <div class="fixed bottom-0 left-0 right-0 z-50 px-4 py-3 bg-white/90 backdrop-blur-md border-t border-slate-200 shadow-[0_-4px_12px_rgba(0,0,0,0.05)] lg:hidden w-full pb-[calc(12px+env(safe-area-inset-bottom))]">
            <div class="flex items-center justify-center gap-3 w-full actions">
            <button class="btn-primary flex-1 h-12 m-0 flex items-center justify-center text-base font-semibold" (click)="applyNow()">Apply Now</button>
            <div class="flex gap-2">
              <button class="btn-secondary h-12 w-12 flex-shrink-0 flex items-center justify-center bg-white rounded-xl border transition-colors p-0" [ngClass]="job.is_saved ? 'text-indigo-600 border-indigo-200 bg-indigo-50' : 'border-slate-200'" (click)="saveJob()">
                <svg class="w-5 h-5" [attr.fill]="job.is_saved ? 'currentColor' : 'none'" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
                  <path d="m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z"></path>
                </svg>
              </button>
              <button class="btn-secondary h-12 w-12 flex-shrink-0 flex items-center justify-center bg-white rounded-xl border border-slate-200 transition-colors p-0" (click)="shareJob()">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
                  <circle cx="18" cy="5" r="3"></circle>
                  <circle cx="6" cy="12" r="3"></circle>
                  <circle cx="18" cy="19" r="3"></circle>
                  <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
                  <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
                </svg>
              </button>
            </div>
          </div>
        </div>

        </div>

        <section id="about" class="job-section" *ngIf="job.company_description">
          <h2>About {{ job.company_name }}</h2>
          <div class="rich-text-content" [innerHTML]="job.company_description"></div>
        </section>

        <section id="description" class="job-section" *ngIf="job.description">
          <h2>Job description</h2>
          <div class="rich-text-content" [innerHTML]="job.description"></div>
        </section>

        <section id="roles" class="job-section" *ngIf="job.roles_and_responsibilities">
          <h2>Roles & responsibilities</h2>
          <div class="rich-text-content" [innerHTML]="job.roles_and_responsibilities"></div>
        </section>

        <section id="required" class="job-section" *ngIf="job.required_skills?.length">
          <h2>Required skills</h2>
          <div class="job-tags">
            <span class="tag" *ngFor="let skill of job.required_skills">{{ skill }}</span>
          </div>
        </section>

        <section id="preferred" class="job-section" *ngIf="job.preferred_skills?.length">
          <h2>Preferred skills</h2>
          <div class="job-tags">
            <span class="tag" *ngFor="let skill of job.preferred_skills">{{ skill }}</span>
          </div>
        </section>

        <section id="eligibility" class="job-section">
          <h2>Eligibility</h2>
          <div class="eligibility-cards">
            <div class="card-left">
              <h4>
                <svg class="w-4 h-4 text-indigo-500" fill="none" stroke="currentColor" stroke-linecap="round"
                  stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
                  <path d="M22 10v6M2 10l10-5 10 5-10 5z"></path>
                  <path d="M6 12v5c3 3 9 3 12 0v-5"></path>
                </svg>
                Education
              </h4>
              <div class="job-tags" *ngIf="job.education?.length; else anyEducation">
                <span class="tag" *ngFor="let edu of job.education">{{ edu }}</span>
              </div>
              <ng-template #anyEducation>
                <div class="job-tags"><span class="tag">Any Degree</span></div>
              </ng-template>
            </div>
            <div class="eligibility-details">
              <span class="label">Minimum CGPA</span>
              <span class="val">{{ job.min_cgpa || 'No minimum' }}</span>

              <span class="label">Year of passing</span>
              <span class="val">{{ job.year_of_passing?.length ? job.year_of_passing.join(', ') : 'Any year' }}</span>

              <span class="label">Experience</span>
              <span class="val">{{ job.experience_level || 'Fresher' }}</span>
            </div>
          </div>
        </section>

        <section id="compensation" class="job-section">
          <h2>Compensation & perks</h2>
          <p class="salary">
            <span class="currency text-emerald-500" *ngIf="job.currency === 'INR'">&#8377;</span>
            <span class="currency text-emerald-500" *ngIf="job.currency === 'USD'">$</span>
            <ng-container *ngIf="job.salary_min && job.salary_max">
              {{ job.salary_min }}–{{ job.salary_max }}
            </ng-container>
            <ng-container *ngIf="job.salary_min && !job.salary_max">
              {{ job.salary_min }}
            </ng-container>
            <ng-container *ngIf="!job.salary_min && job.salary_max">
              Up to {{ job.salary_max }}
            </ng-container>
            <ng-container *ngIf="!job.salary_min && !job.salary_max">
              Not disclosed
            </ng-container>
            <span *ngIf="job.payment_frequency" class="text-sm font-normal text-slate-500"> {{ job.payment_frequency
              }}</span>
          </p>
          <div class="perks-tags" *ngIf="job.perks_and_benefits?.length">
            <span class="perk-tag" *ngFor="let perk of job.perks_and_benefits">
              <svg class="w-3.5 h-3.5 text-emerald-500" fill="none" stroke="currentColor" stroke-linecap="round"
                stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
                <path d="M20 6 9 17l-5-5"></path>
              </svg> {{ perk }}
            </span>
          </div>
        </section>

      </div>
    </div>

    <div class="job-right w-full lg:w-auto mt-6 lg:mt-0">
      <div class="apply-card hidden lg:block">
        <div class="apply-header hidden lg:flex">
          <div class="job-logo-small">
            <img [src]="job.company_logo || 'https://ui-avatars.com/api/?name=' + job.company_name"
              [alt]="job.company_name">
          </div>
          <div class="apply-header-info">
            <h4>{{ job.job_title }}</h4>
            <p>{{ job.company_name }}</p>
            <div class="mt-1">
              <span
                class="badge bg-blue-50 text-blue-700 border-blue-100 text-xs py-0.5 px-2 inline-flex items-center">
                <svg class="w-3.5 h-3.5 text-blue-600 mr-1" fill="none" stroke="currentColor" stroke-linecap="round"
                  stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
                  <rect width="20" height="14" x="2" y="5" rx="2"></rect>
                  <line x1="2" x2="22" y1="10" y2="10"></line>
                </svg>
                <span class="font-medium mr-0.5" *ngIf="job.currency === 'INR'">&#8377;</span><span
                  class="font-medium mr-0.5" *ngIf="job.currency === 'USD'">$</span>
                <ng-container *ngIf="job.salary_min && job.salary_max">
                  {{ job.salary_min }}–{{ job.salary_max }}
                </ng-container>
                <ng-container *ngIf="job.salary_min && !job.salary_max">
                  {{ job.salary_min }}
                </ng-container>
                <ng-container *ngIf="!job.salary_min && job.salary_max">
                  Up to {{ job.salary_max }}
                </ng-container>
                <ng-container *ngIf="!job.salary_min && !job.salary_max">
                  Not disclosed
                </ng-container>
                <span *ngIf="job.payment_frequency" class="text-[10px] font-normal opacity-80 whitespace-pre"> {{
                  job.payment_frequency }}</span>
              </span>
            </div>
          </div>
        </div>
        <button class="btn-primary w-full" (click)="applyNow()">Apply Now</button>
        <div class="actions relative">
          <button class="btn-secondary flex-1" [ngClass]="{'text-indigo-600': job.is_saved}" (click)="saveJob()"><svg
              class="w-4 h-4 mr-2" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
              stroke-width="2" viewBox="0 0 24 24">
              <path d="m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z"></path>
            </svg> Save Job</button>
          <button class="btn-icon" (click)="shareJob()"><svg class="w-4 h-4" fill="none" stroke="currentColor"
              stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
              <circle cx="18" cy="5" r="3"></circle>
              <circle cx="6" cy="12" r="3"></circle>
              <circle cx="18" cy="19" r="3"></circle>
              <line x1="8.59" x2="15.42" y1="13.51" y2="17.49"></line>
              <line x1="15.41" x2="8.59" y1="6.51" y2="10.49"></line>
            </svg></button>

          <!-- Backdrop to close dropdown -->
          <div *ngIf="showShareFallback" class="fixed inset-0 z-40" (click)="toggleShareFallback()"></div>

          <!-- Custom Share Dropdown Fallback -->
          <div *ngIf="showShareFallback"
            class="absolute right-0 top-12 bg-white rounded-lg shadow-xl border border-slate-100 p-2 z-50 flex flex-col gap-1 w-48">
            <button
              class="flex items-center gap-2 px-3 py-2 text-sm text-slate-700 hover:bg-slate-50 rounded-md transition w-full text-left"
              (click)="shareTo('whatsapp')">
              <svg class="w-4 h-4 text-emerald-500" viewBox="0 0 24 24" fill="currentColor">
                <path
                  d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 0 0-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z">
                </path>
              </svg> WhatsApp
            </button>
            <button
              class="flex items-center gap-2 px-3 py-2 text-sm text-slate-700 hover:bg-slate-50 rounded-md transition w-full text-left"
              (click)="shareTo('linkedin')">
              <svg class="w-4 h-4 text-blue-600" viewBox="0 0 24 24" fill="currentColor">
                <path
                  d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z">
                </path>
              </svg> LinkedIn
            </button>
            <button
              class="flex items-center gap-2 px-3 py-2 text-sm text-slate-700 hover:bg-slate-50 rounded-md transition w-full text-left"
              (click)="shareTo('twitter')">
              <svg class="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
                <path
                  d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z">
                </path>
              </svg> X (Twitter)
            </button>
            <hr class="my-1 border-slate-100">
            <button id="copy-btn"
              class="flex items-center gap-2 px-3 py-2 text-sm text-slate-700 hover:bg-slate-50 rounded-md transition w-full text-left"
              (click)="copyLink()">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" viewBox="0 0 24 24">
                <rect width="14" height="14" x="8" y="8" rx="2" ry="2"></rect>
                <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"></path>
              </svg> Copy Link
            </button>
          </div>
        </div>
      </div>

      <div class="hiring-card">
        <div class="hiring-header">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
            stroke-width="2" viewBox="0 0 24 24">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
          </svg>
          <h3>Hiring Process</h3>
        </div>

        <p class="hiring-desc" *ngIf="job.hiring_process?.length">
          A secure and objective evaluation process.
        </p>

        <div class="hiring-steps" *ngIf="job.hiring_process?.length">
          <div class="step" *ngFor="let step of job.hiring_process; let i = index">
            <div class="step-num">{{ i + 1 }}</div>
            <div class="step-info">
              <h4>{{ step }}</h4>
            </div>
          </div>
        </div>

        <div class="hiring-steps" *ngIf="!job.hiring_process?.length">
          <div class="step">
            <div class="step-num">1</div>
            <div class="step-info">
              <h4>Application Review</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="!isLoading && !job">
    <div class="flex flex-col justify-center items-center py-20 w-full h-full text-center">
      <h2 class="text-2xl font-semibold text-slate-800 mb-2">Job not found</h2>
      <p class="text-slate-500 mb-6">The job you are looking for does not exist or has been removed.</p>
      <a routerLink="/" class="px-6 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition">Go back to
        Jobs</a>
    </div>
  </ng-container>
</div>